import paths from '../../paths'
import { META } from '../../constants/meta'
import { getLangFromPath } from '../../i18next'

export const createLink = (path: string) => {
    if (path.includes('/contributions/')) {
        if (path.includes('/photo/')) return paths.searchContributionsPhoto
        if (path.includes('/video/')) return paths.searchContributionsVideo
        return paths.searchContributions
    }
    if (path.includes('/photo/')) return paths.searchPhoto
    if (path.includes('/video/')) return paths.searchVideo
    return paths.search
}

export const createReversedLink = (path: string) => {
    if (path.includes('/contributions/')) {
        if (path.includes('/photo/')) return paths.searchPhoto
        if (path.includes('/video/')) return paths.searchVideo
        return paths.search
    }
    if (path.includes('/photo/')) return paths.searchContributionsPhoto
    if (path.includes('/video/')) return paths.searchContributionsVideo
    return paths.searchContributions
}

export const createTagLink = (path: string, currentSlug: string) => {
    const isSearch = path.includes('query')
    const addTag = () => (isSearch ? `?query=${currentSlug}` : currentSlug)

    if (path.includes('/photo/')) return '/tags/photo/' + addTag()
    if (path.includes('/video/')) return '/tags/video/' + addTag()
    return '/tags/' + addTag()
}
export const createContributionLink = (path: string, currentSlug: string) => {
    const isSearch = path.includes('query')
    const addTag = () => (isSearch ? `?query=${currentSlug}` : currentSlug)

    if (path.includes('/photo/')) return '/tags/contributions/photo/' + addTag()
    if (path.includes('/video/')) return '/tags/contributions/video/' + addTag()
    return '/tags/contributions/' + addTag()
}

export const getSlugFromPath = (path: string) => {
    const query = path.includes('query=')
        ? path.includes('p=')
            ? path.split('query=').pop().split('&p=').shift()
            : path.split('query=').pop()
        : null

    if (query) return query
    return path.includes('p=') ? path.split('/').pop().split('?p=').shift() : path.split('/').pop()
}

export const createPageDescription = (path: string, tag: string) => {
    const lang = getLangFromPath(path)
    const isVideo = path.includes('/video/')
    const isPhoto = path.includes('/photo/')
    const isContribution = path.includes('/contributions/')
    if (isContribution) {
        if (tag) {
            if (isPhoto) return META.searchContributionsResultsPhoto[lang].description.replace('{TAG}', tag)
            if (isVideo) return META.searchContributionsResultsVideo[lang].description.replace('{TAG}', tag)
            return META.searchContributionsResults[lang].description.replace('{TAG}', tag)
        }
        if (isPhoto) return META.searchContributionsPhoto[lang].description
        if (isVideo) return META.searchContributionsVideo[lang].description
        return META.searchContributions[lang].description
    }
    if (tag) {
        if (isPhoto) return META.searchTagsResultsPhoto[lang].description.replace('{TAG}', tag)
        if (isVideo) return META.searchTagsResultsVideo[lang].description.replace('{TAG}', tag)
        return META.searchTagsResults[lang].description.replace('{TAG}', tag)
    }
    if (isPhoto) return META.searchTagsPhoto[lang].description
    if (isVideo) return META.searchTagsVideo[lang].description
    return META.searchTags[lang].description
}

export const createPageTitle = (path: string, tag: string) => {
    const lang = getLangFromPath(path)
    const isVideo = path.includes('/video/')
    const isPhoto = path.includes('/photo/')
    const isContribution = path.includes('/contributions/')
    if (isContribution) {
        if (tag) {
            if (isPhoto) return META.searchContributionsResultsPhoto[lang].title.replace('{TAG}', tag)
            if (isVideo) return META.searchContributionsResultsVideo[lang].title.replace('{TAG}', tag)
            return META.searchContributionsResults[lang].title.replace('{TAG}', tag)
        }
        if (isPhoto) return META.searchContributionsPhoto[lang].title
        if (isVideo) return META.searchContributionsVideo[lang].title
        return META.searchContributions[lang].title
    }
    if (tag) {
        if (isPhoto) return META.searchTagsResultsPhoto[lang].title.replace('{TAG}', tag)
        if (isVideo) return META.searchTagsResultsVideo[lang].title.replace('{TAG}', tag)
        return META.searchTagsResults[lang].title.replace('{TAG}', tag)
    }
    if (isPhoto) return META.searchTagsPhoto[lang].title
    if (isVideo) return META.searchTagsVideo[lang].title
    return META.searchTags[lang].title
}
